import { mapActions } from 'vuex';
import TranslationMixin from '~/mixins/TranslationMixin';

export default {
    mixins: [TranslationMixin],

    data() {
        return {
            filtersActive: false,
        };
    },

    methods: {
        ...mapActions({
            showOverlay: 'ui/showMenuOverlay',
            hideOverlay: 'ui/hideOverlay',
        }),
        openFilters() {
            this.filtersActive = true;
            this.showOverlay();
        },
        closeFilters() {
            this.filtersActive = false;
            this.hideOverlay();
        },
    },
};
